import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { NavLink } from 'react-router-dom';
import { Theme } from '../../config/theme.js';
import { slide as Menu } from 'react-burger-menu'

const BURGER_ICON = require('./burger.svg');
const CLOSE_ICON = require('./close.svg');
const SEARCH_ICON = require('./search.svg');

export default class BurgerMenu extends Component {
  render () {
    return (
      <Menu
        customCrossIcon={ <img src={CLOSE_ICON} /> }
        customBurgerIcon={ <img src={BURGER_ICON} /> }
        width={ '100%' }>
        <div className={css(styles.container)}>
          <NavLink className={css(styles.link)} to={'/search'} activeClassName={css(styles.active_link)}>
            <img src={SEARCH_ICON} />
          </NavLink>
          <NavLink className={css(styles.link)} to={'/'} activeClassName={css(styles.active_link)}>
            Home
          </NavLink>
          <NavLink className={css(styles.link)} to={'/music'} activeClassName={css(styles.active_link)}>
            Music
          </NavLink>
          <NavLink className={css(styles.link)} to={'/features'} activeClassName={css(styles.active_link)}>
            Featured
          </NavLink>
          <NavLink className={css(styles.link)} to={'/interviews'} activeClassName={css(styles.active_link)}>
            Interviews
          </NavLink>
          <NavLink className={css(styles.link)} to={'/contact'} activeClassName={css(styles.active_link)}>
            Contact
          </NavLink>
        </div>
      </Menu>
    );
  }
}

const styles = StyleSheet.create({
  burger_bar: {
    position: 'fixed',
    top: 0,
    left: 0,
  },
  container: {
    boxSizing: 'border-box',
    height: window.innerHeight - (window.innerHeight * 0.4),
    marginTop: '40%',
    marginBottom: '40%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  link: {
    flex: 1,
    fontFamily: Theme.fontFamily_secondary,
    color: Theme.black,
    fontSize: 22,
    fontWeight: 'bold',
  },
});



// WEBPACK FOOTER //
// ./src/components/BurgerMenu/index.js